import React, { Component } from "react";
import { translate } from "react-i18next";

import Navigation from "Navigation";

class App extends Component {
	render() {
		return <Navigation />;
	}
}

export { App };

export default translate()(App);


// WEBPACK FOOTER //
// ./src/App.js